import { render, staticRenderFns } from "./FreehandDrawSVG.vue?vue&type=template&id=9ed9949e"
import script from "./FreehandDrawSVG.vue?vue&type=script&lang=js"
export * from "./FreehandDrawSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports